import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		minHeight: 70,
		marginBottom: theme.spacing(2),
		padding: theme.spacing(1.25, 2),
		backgroundColor: theme.palette.background.paper,
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 14,
		boxShadow: theme.mode === "light"
			? "0 8px 24px rgba(15, 23, 42, 0.055)"
			: "0 8px 24px rgba(0, 0, 0, 0.2)",
		[theme.breakpoints.down("sm")]: {
			alignItems: "flex-start",
			flexDirection: "column",
			gap: theme.spacing(1),
			padding: theme.spacing(1.5),
		},
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
